import { createStructuredSelector } from "reselect";
import {
    REQUEST_PRODUCT,
    REQUEST_PRODUCT_SUCCESS,
    REQUEST_PRODUCT_ERROR,
    REQUEST_SUPPLIER,
    REQUEST_SUPPLIER_SUCCESS,
    REQUEST_SUPPLIER_ERROR,
    REQUEST_DELIVERY_ORDER,
    REQUEST_DELIVERY_ORDER_SUCCESS,
    REQUEST_DELIVERY_ORDER_ERROR,
    REQUEST_UNIT_HEALTH,
    REQUEST_UNIT_HEALTH_SUCCESS,
    REQUEST_UNIT_HEALTH_ERROR,
    REQUEST_TICKET,
    REQUEST_TICKET_SUCCESS,
    REQUEST_TICKET_ERROR,
    REQUEST_SERIAL,
    REQUEST_SERIAL_SUCCESS,
    REQUEST_SERIAL_ERROR,
    REQUEST_REQ_TYPE,
    REQUEST_REQ_TYPE_SUCCESS,
    REQUEST_REQ_TYPE_ERROR,
    REQUEST_PRIORITY,
    REQUEST_PRIORITY_SUCCESS,
    REQUEST_PRIORITY_ERROR,
    REQUEST_DOCUMENT_TYPE,
    REQUEST_DOCUMENT_TYPE_SUCCESS,
    REQUEST_DOCUMENT_TYPE_ERROR,
    REQUEST_STATUS,
    REQUEST_STATUS_SUCCESS,
    REQUEST_STATUS_ERROR,
    REQUEST_LIST,
    REQUEST_LIST_SUCCESS,
    REQUEST_LIST_ERROR,
    REQUEST_LIST_SEARCH_CHANGE,
    REQUEST_LIST_PAGE_SET,
    REQUEST_DETAIL,
    REQUEST_DETAIL_SUCCESS,
    REQUEST_DETAIL_ERROR,
    REQUEST_MODAL_SET,
    REQUEST_DATA_SET,
    REQUEST_EDIT_MODAL_SET,
    REQUEST_EDIT_CHANGE_SET,
    REQUEST_EDIT,
    REQUEST_EDIT_SUCCESS,
    REQUEST_EDIT_ERROR,
    REQUEST_UPLOAD_SET,
    REQUEST_UPLOAD_SET_SUCCESS,
    REQUEST_UPLOAD_SET_ERROR,
    REQUEST_UPLOAD_RESET,
} from "../../actions";

export const NAME = 'request';

export const RequestProduct = (data) => ({
    type: REQUEST_PRODUCT,
    payload: data
});

export const RequestProductSuccess = (data) => ({
    type: REQUEST_PRODUCT_SUCCESS,
    payload: data
});

export const RequestProductError = (error) => ({
    type: REQUEST_PRODUCT_ERROR,
    payload: error
});

export const RequestSupplier = (data) => ({
    type: REQUEST_SUPPLIER,
    payload: data
});

export const RequestSupplierSuccess = (data) => ({
    type: REQUEST_SUPPLIER_SUCCESS,
    payload: data
});

export const RequestSupplierError = (error) => ({
    type: REQUEST_SUPPLIER_ERROR,
    payload: error
});

export const RequestDeliveryOrder = (data) => ({
    type: REQUEST_DELIVERY_ORDER,
    payload: data
});

export const RequestDeliveryOrderSuccess = (data) => ({
    type: REQUEST_DELIVERY_ORDER_SUCCESS,
    payload: data
});

export const RequestDeliveryOrderError = (error) => ({
    type: REQUEST_DELIVERY_ORDER_ERROR,
    payload: error
});

export const RequestUnitHealth = (data) => ({
    type: REQUEST_UNIT_HEALTH,
    payload: data
});

export const RequestUnitHealthSuccess = (data) => ({
    type: REQUEST_UNIT_HEALTH_SUCCESS,
    payload: data
});

export const RequestUnitHealthError = (error) => ({
    type: REQUEST_UNIT_HEALTH_ERROR,
    payload: error
});

export const RequestTicket = (data) => ({
    type: REQUEST_TICKET,
    payload: data
});

export const RequestTicketSuccess = (data) => ({
    type: REQUEST_TICKET_SUCCESS,
    payload: data
});

export const RequestTicketError = (error) => ({
    type: REQUEST_TICKET_ERROR,
    payload: error
});

export const RequestSerial = (data) => ({
    type: REQUEST_SERIAL,
    payload: data
});

export const RequestSerialSuccess = (data) => ({
    type: REQUEST_SERIAL_SUCCESS,
    payload: data
});

export const RequestSerialError = (error) => ({
    type: REQUEST_SERIAL_ERROR,
    payload: error
});

export const RequestReqType = (data) => ({
    type: REQUEST_REQ_TYPE,
    payload: data
});

export const RequestReqTypeSuccess = (data) => ({
    type: REQUEST_REQ_TYPE_SUCCESS,
    payload: data
});

export const RequestReqTypeError = (error) => ({
    type: REQUEST_REQ_TYPE_ERROR,
    payload: error
});

export const RequestPriority = (data) => ({
    type: REQUEST_PRIORITY,
    payload: data
});

export const RequestPrioritySuccess = (data) => ({
    type: REQUEST_PRIORITY_SUCCESS,
    payload: data
});

export const RequestPriorityError = (error) => ({
    type: REQUEST_PRIORITY_ERROR,
    payload: error
});

export const RequestDocumentType = (data) => ({
    type: REQUEST_DOCUMENT_TYPE,
    payload: data
});

export const RequestDocumentTypeSuccess = (data) => ({
    type: REQUEST_DOCUMENT_TYPE_SUCCESS,
    payload: data
});

export const RequestDocumentTypeError = (error) => ({
    type: REQUEST_DOCUMENT_TYPE_ERROR,
    payload: error
});

export const RequestStatus = (data) => ({
    type: REQUEST_STATUS,
    payload: data
});

export const RequestStatusSuccess = (data) => ({
    type: REQUEST_STATUS_SUCCESS,
    payload: data
});

export const RequestStatusError = (error) => ({
    type: REQUEST_STATUS_ERROR,
    payload: error 
});


export const RequestList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: REQUEST_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const RequestListSuccess = (data) => ({
    type: REQUEST_LIST_SUCCESS,
    payload: data
});

export const RequestListError = (error) => ({
    type: REQUEST_LIST_ERROR,
    payload: error
});

export const RequestListSearchChange = (data) => ({
    type: REQUEST_LIST_SEARCH_CHANGE,
    payload: data
});

export const RequestListPageSet = (data) => ({
    type: REQUEST_LIST_PAGE_SET,
    payload: data
});

export const RequestDetail = (data) => ({
    type: REQUEST_DETAIL,
    payload: data
});

export const RequestDetailSuccess = (data) => ({
    type: REQUEST_DETAIL_SUCCESS,
    payload: data
});

export const RequestDetailError = (error) => ({
    type: REQUEST_DETAIL_ERROR,
    payload: error
});

export const RequestModalSet = (data) => ({
    type: REQUEST_MODAL_SET,
    payload: data
});

export const RequestDataSet = (data) => ({
    type: REQUEST_DATA_SET,
    payload: data
});


export const RequestEditModalSet = (data) => ({
    type: REQUEST_EDIT_MODAL_SET,
    payload: data
});

export const RequestEditChangeSet = (data) => ({
    type: REQUEST_EDIT_CHANGE_SET,
    payload: data
});

export const RequestEdit = (page, num_page, orderBy, filters, data) => ({
    type: REQUEST_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const RequestEditSuccess = (message) => ({
    type: REQUEST_EDIT_SUCCESS,
    payload: message
});

export const RequestEditError = (error) => ({
    type: REQUEST_EDIT_ERROR,
    payload: error
});

export const RequestUploadSet = (file) => ({
    type: REQUEST_UPLOAD_SET,
    payload: { file },
});

export const RequestUploadSetSuccess = (items) => ({
    type: REQUEST_UPLOAD_SET_SUCCESS,
    payload: items,
});

export const RequestUploadSetError = (error) => ({
    type: REQUEST_UPLOAD_SET_ERROR,
    payload: error,
});

export const RequestUploadReset = () => ({
    type: REQUEST_UPLOAD_RESET
});

const request = (state) => state[NAME];

export const RequestSelector = createStructuredSelector({
    request 
}) 
